import VAvatarOption from './index.vue';

export default {
  install: (Vue) => Vue.component('VAvatarOption', VAvatarOption),
};
